(function ($) {
  'use strict';

  window.ys.lv2022 = new LaVuelta2022();

  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('lv_2022')) {
    window.ys.lv2022Contest = new LaVuelta2022.Contest();
  }
}).bind(window)(jQuery);
